const ECOPAYZ = 'ECOPAYZ';

export function makePaymentOptions(payload) {
  return payload.map(paymentOptionPayload => makePaymentOption(paymentOptionPayload));
}

export function makePaymentOption(payload) {
  let paymentOption = new PaymentOption(payload.id, payload.type, payload.fields.email);
  if (payload.type === 'ECOPAYZ' || payload.type === 'BITCOIN') {
    paymentOption.addExtra('accountId', payload.fields.account_id ? payload.fields.account_id : payload.fields.account);
  }

  return paymentOption;
}

class PaymentOption {
  constructor(id, type, email) {
    this.id = +id;
    this.type = type;
    this.email = email;

    this.activeTab = false;

    this.extras = {};
  }


  isEcopayz() {
    return this.type === ECOPAYZ;
  }

  addExtra(key, value) {
    this.extras[key] = value;
  }
}

// TODO: Don't export by default.
export default PaymentOption;



// WEBPACK FOOTER //
// ./client/app/shared/models/payment-option.model.js